module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }